import React from 'react'

import { NavLink } from 'react-router-dom'

import { SiteContext } from 'context/site-context'

import {
  getAddress,
  getProfileUrl,
  isWebpSupported,
} from 'helpers'

import TopCities from 'components/atoms/TopCities'

import './index.scss'

const MAX_CATEGORIES_TO_SHOW = 3
const MAX_LISTINGS_TO_SHOW = 2

const TopBusinesses = ({ className = '' }) => {
  const [ site, setSite ] = React.useContext(SiteContext)

  return <React.Fragment>
    {Object.entries(site.topBusinesses).length > 0 ? <div className={`top-businesses-container ${className}`}>
      <div className="container">
        <h3>Top <span className="highlight">Businesses</span> in {site.location}</h3>
        <div className="categories-wrapper">
          {
            Object.entries(site.topBusinesses)
              .filter( key => key[0] !== site.upsellCategory ) // Filter out any that match the hero
              .filter( (key, i) => i < MAX_CATEGORIES_TO_SHOW ) // Restrict the number of categories to render
              .map( key => {
              return <div className="panel" key={key[0]}>
              <h3 style={{
                backgroundImage: `url(${isWebpSupported() && site.discover[key[0]].imageWebP ? site.discover[key[0]].imageWebP : site.discover[key[0]].image})`,
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'}}><span>{site.discover[key[0]].label}</span></h3>
              <div className="listings-container">
                <ul>
                  {key[1].results?.locations?.map( (listing, i) => {
                    return i < MAX_LISTINGS_TO_SHOW ? <li key={listing.id}><a href={getProfileUrl(site, listing)}>
                      <p>{listing.name}</p>
                      {listing.address && <address>{getAddress(listing.address)}</address>}
                    </a></li> : null}
                  )}
                </ul>
                <div className="actions-container">
                  <NavLink to={`/results?term=${key[0]}&where=${site.location}${!!new URLSearchParams(window.location.search).get('useSampleData') ? '&useSampleData=true' : ''}`}  className="button-trigger mini">More...</NavLink>
                </div>
              </div>
            </div>
          })
        }
        </div>
      </div>
    </div> : <div className="container">
      <h3>Popular <span className="highlight">Cities</span></h3>
      <TopCities />
    </div>}
  </React.Fragment>
}

export default TopBusinesses
